import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

// Typefaces
import { proximaNovaTypeface } from './proximaNovaTypeface';

export const GlobalStyles = createGlobalStyle<{ $additionalCss?: any }>`
  ${normalize}
  ${proximaNovaTypeface}

  * {
    box-sizing: border-box;
  }

  html {
    font: -apple-system-body;
  }

  body {
    font-family: 'Proxima Nova', sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  ${({ $additionalCss }) => $additionalCss}
`;
